export default __webpack_public_path__ + "img/user-example.67184876.png";